import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { Send, Mail, User, MessageSquare, Loader } from 'lucide-react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(prevStatus => ({
      ...prevStatus,
      submitting: true
    }));

    try {
      await emailjs.send(
        'service_sk10974', // Replace with your EmailJS service ID
        'template_ipah54k', // Replace with your EmailJS template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
          to_name: 'Swanpoint Team',
        },
        's_RkES8CnQ9twvzVF' // Replace with your EmailJS public key
      );

      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: "Message sent successfully!" }
      });

      setFormData({
        name: '',
        email: '',
        message: ''
      });

      setTimeout(() => {
        setStatus({
          submitted: false,
          submitting: false,
          info: { error: false, msg: null }
        });
      }, 3000);

    } catch (error) {
      setStatus({
        submitted: false,
        submitting: false,
        info: { error: true, msg: "An error occurred. Please try again later." }
      });
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-content">
        <div className="contact-info">
          <h1>Get in Touch</h1>
          <p>
            Have questions about our investment strategies or want to learn more? 
            Our team is here to help.
          </p>
          
          <div className="contact-details">
            <div className="contact-item">
              <Mail className="icon" />
              <div>
                <h3>Email Us</h3>
                <p>growth_sphere@outlook.com</p>
              </div>
            </div>
            
            {/* Add more contact details as needed */}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">
              <User className="input-icon" />
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your name"
              disabled={status.submitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">
              <Mail className="input-icon" />
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              disabled={status.submitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">
              <MessageSquare className="input-icon" />
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="How can we help you?"
              disabled={status.submitting}
              rows="5"
            ></textarea>
          </div>

          <button 
            type="submit" 
            className={`submit-button ${status.submitting ? 'loading' : ''}`}
            disabled={status.submitting}
          >
            {status.submitting ? (
              <Loader className="loading-icon" />
            ) : (
              <>
                Send Message
                <Send className="button-icon" />
              </>
            )}
          </button>

          {status.info.msg && (
            <div className={`status-message ${status.info.error ? 'error' : 'success'}`}>
              {status.info.msg}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default Contact;